import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";

const isAndroidMetaInAppBrowser = () => {
  const ua = navigator.userAgent || "";
  return /Android/i.test(ua) && /Instagram|FBAN|FBAV|FB_IAB/i.test(ua);
};

const openInBrowser = () => {
  const target = window.location.href.replace(/^https?:\/\//, "");
  window.location.href = `intent://${target}#Intent;scheme=https;end;`;
};

export const InAppBrowserNotice = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isAndroidMetaInAppBrowser()) return;
    setShow(true);
    openInBrowser();
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="iab-notice-banner"
      className="fixed top-0 left-0 right-0 z-[100] bg-gold text-[#0c0c0c] text-xs sm:text-sm px-4 py-2.5 flex items-center justify-between gap-3"
    >
      <span>Per una navigazione più fluida, apri il sito nel browser.</span>
      <button
        onClick={openInBrowser}
        data-testid="iab-notice-open-browser"
        className="shrink-0 inline-flex items-center gap-1.5 bg-[#0c0c0c] text-gold text-xs font-medium uppercase tracking-wide px-3 py-1.5 hover:bg-[#1a1a1a] transition-colors"
      >
        Apri nel browser <ExternalLink size={13} />
      </button>
    </div>
  );
};

export default InAppBrowserNotice;
